import Model, { attr, belongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type CompanyModel from './company';
import type OrderModel from './order';
import type SupplierItemModel from './supplier-item';
import { createHTMLProps, htmlType } from 'bcl/misc/decorators';

@createHTMLProps
export default class OrderEntryModel extends Model {
  declare [Type]: 'order-entry';
  @belongsTo('order', { async: false, inverse: 'orderEntries' })
  declare order: OrderModel;
  @belongsTo('supplier-item', { async: false, inverse: 'orderEntries' })
  declare supplier_item: SupplierItemModel;
  @attr('number')
  declare amount: number;
  @htmlType('number')
  @attr('number')
  declare amount_delivered?: number;
  @attr()
  declare position: number;
  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;
  @attr()
  declare created_at: string;
  @attr()
  declare updated_at: string;
}
